/* Produktkacheln: Titel pro Reihe gleich hoch, damit die Bewertungen auf einer Linie stehen */
(function () {
  'use strict';
  function angleichen() {
    var namen = document.querySelectorAll('.armano-products .armano-products__name');
    namen.forEach(function (n) { n.style.removeProperty('min-height'); });
    var reihen = {};
    namen.forEach(function (n) {
      var item = n.closest('.armano-products__item');
      if (!item || !item.offsetParent) return;
      var grid = item.parentElement;
      var key = (grid.dataset.ctGrid || (grid.dataset.ctGrid = Math.random().toString(36).slice(2))) + ':' + Math.round(item.getBoundingClientRect().top + window.scrollY);
      (reihen[key] = reihen[key] || []).push(n);
    });
    Object.keys(reihen).forEach(function (k) {
      var r = reihen[k];
      if (r.length < 2) return;
      var max = 0;
      r.forEach(function (n) { max = Math.max(max, n.getBoundingClientRect().height); });
      r.forEach(function (n) { n.style.setProperty('min-height', Math.ceil(max) + 'px', 'important'); });
    });
  }
  var t = 0;
  function spaeter() { clearTimeout(t); t = setTimeout(angleichen, 120); }
  function los() {
    angleichen();
    window.addEventListener('resize', spaeter);
    window.addEventListener('load', spaeter);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(spaeter);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
})();
